import { inject, Injectable, InjectionToken, signal, WritableSignal } from '@angular/core';
import { APP_CONFIG, ImproverAngularEnvironment } from '@improver/app-config';
import { ApiService, mapApiResponse } from '@improver/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

interface GeneralIssueEndpoints {
  GET_ISSUE: (lang: string) => string;
}

export const GENERAL_ISSUE_ENDPOINTS = new InjectionToken<GeneralIssueEndpoints>('endpoints.maintenance-general-issue', {
  factory: () => {
    const environment: ImproverAngularEnvironment = inject(APP_CONFIG);
    const envBase = `${environment.services.authorization}`;
    const issueBase = `${envBase}/issues`;

    return {
      GET_ISSUE: (lang: string) => `${issueBase}/${lang}`,
    };
  },
});

@Injectable({ providedIn: 'root' })
export class MaintenanceGeneralIssueApiService {
  private readonly apiService = inject(ApiService);
  private readonly endpoints: GeneralIssueEndpoints = inject(GENERAL_ISSUE_ENDPOINTS);
  readonly hasGeneralIssueMessage: WritableSignal<boolean> = signal(false);

  getGeneralIssue(languageCode: string): Observable<string> {
    return this.apiService.get(this.endpoints.GET_ISSUE(languageCode)).pipe(
      mapApiResponse(),
      map((response) => response?.message),
      tap((message) => this.hasGeneralIssueMessage.set(!!message))
    );
  }
}
